export default __webpack_public_path__ + "static/media/switch-on.4b5d61aa.svg";